/**
 * Human-readable display names for SOLA tool calls.
 *
 * Used by ToolHeader and any other component that needs a friendly
 * label for a given tool name.
 */
export const TOOL_DISPLAY_NAMES: Record<string, string> = {
  // Analytics
  queryData: "Analytics Query",
  exportAnalyticsData: "Export Analytics",
  planReport: "Report Plan",
  writeAnalysisReport: "Analysis Report",

  // Candidates
  searchCandidates: "Search Candidates",
  getCandidate: "Candidate Details",
  createCandidate: "Create Candidate",
  updateCandidateData: "Update Candidate",
  deleteCandidate: "Delete Candidate",
  addCandidateNote: "Add Note",
  importCandidateFromResume: "Import Resume",
  generateResume: "Generate Resume",
  addCandidateSkill: "Add Skill",
  removeCandidateSkill: "Remove Skill",
  addCandidateRole: "Add Role",
  updateCandidateRole: "Update Role",
  removeCandidateRole: "Remove Role",
  addCandidateProject: "Add Project",
  updateCandidateProject: "Update Project",
  removeCandidateProject: "Remove Project",
  addCandidateEducation: "Add Education",
  updateCandidateEducation: "Update Education",
  removeCandidateEducation: "Remove Education",

  // Contacts
  searchContacts: "Search Contacts",
  getContact: "Contact Details",
  createContact: "Create Contact",
  updateContact: "Update Contact",
  deleteContact: "Delete Contact",

  // Floats
  searchFloats: "Search Floats",
  getFloat: "Float Details",
  createFloat: "Create Float",
  updateFloat: "Update Float",
  deleteFloat: "Delete Float",
  fetchCandidatesForFloat: "Float Candidates",
  duplicateFloat: "Duplicate Float",
  getFloatInteractions: "Float Interactions",
  createShareLink: "Create Share Link",

  // Research
  searchWeb: "Web Search",

  // Email
  getEmailDraft: "Email Draft",
  createFloatEmail: "Create Email",
  sendTestEmail: "Send Test Email",
  sendEmailCampaign: "Send Campaign",
  createScheduledMessage: "Schedule Message",
  getScheduledMessages: "Scheduled Messages",

  // Dashboard
  getDashboardStats: "Dashboard Stats",
  getTeamDashboardStats: "Team Stats",
  getTopLeads: "Top Leads",

  // Integrations
  getIntegrationStatus: "Integration Status",
  disconnectIntegration: "Disconnect Integration",
  proxyIntegrationRequest: "Integration Request",
  clearIntegrationCache: "Clear Cache",

  // Team
  getTeamCandidates: "Team Candidates",
  getTeamCandidate: "Team Candidate",
  duplicateTeamCandidate: "Duplicate Candidate",
  getTeamFloats: "Team Floats",
  getTeamFloat: "Team Float",
  duplicateTeamFloat: "Duplicate Float",
  getTeamContacts: "Team Contacts",
  getTeamContact: "Team Contact",
  duplicateTeamContact: "Duplicate Contact",

  // Notifications
  getNotifications: "Notifications",
  markNotificationsRead: "Mark Read",

  // Tags
  getTags: "Tags",

  // Quality Control
  judgeConversation: "Conversation Judge",
};

/**
 * Get a human-readable display name for a tool.
 * Falls back to converting camelCase to Title Case.
 */
export function getToolDisplayName(toolName: string): string {
  return TOOL_DISPLAY_NAMES[toolName] || toolName.replace(/([A-Z])/g, " $1").trim();
}
